import React, { useState } from 'react';
import { isDiwaliOfferActive, getRegularPlanDiscountPerNight } from '../utils/offers';
import './BookingSummary.css';
import { FaCalendarAlt, FaBed, FaUser, FaWifi, FaCar, FaSnowflake, FaRegClock, FaToilet, FaLock, FaTools, FaMoneyBillWave, FaPhone, FaEnvelope, FaBolt, FaConciergeBell } from 'react-icons/fa'; // Removed FaRegCreditCard for SVG

const RazorpayLogo = () => (
  <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 26.53" style={{height: '1.25em', verticalAlign: 'middle'}} xmlSpace="preserve">
      <style type="text/css">{`.st0{fill:#3395FF;}.st1{fill:#072654;}`}</style>
      <g>
        <polygon className="st1" points="11.19,9.03 7.94,21.47 0,21.47 1.61,15.35 11.19,9.03"/>
        <path className="st1" d="M28.09,5.08C29.95,5.09,31.26,5.5,32,6.33s0.92,2.01,0.51,3.56c-0.27,1.06-0.82,2.03-1.59,2.8 c-0.8,0.8-1.78,1.38-2.87,1.68c0.83,0.19,1.34,0.78,1.5,1.79l0.03,0.22l0.6,5.09h-3.7l-0.62-5.48c-0.01-0.18-0.06-0.36-0.15-0.52 c-0.09-0.16-0.22-0.29-0.37-0.39c-0.31-0.16-0.65-0.24-1-0.25h-0.21h-2.28l-1.74,6.63h-3.46l4.3-16.38H28.09L28.09,5.08z M122.88,9.37l-4.4,6.34l-5.19,7.52l-0.04,0.04l-1.16,1.68l-0.04,0.06L112,25.09l-1,1.44h-3.44l4.02-5.67l-1.82-11.09h3.57 l0.9,7.23l4.36-6.19l0.06-0.09l0.07-0.1l0.07-0.09l0.54-1.15H122.88L122.88,9.37z M92.4,10.25c0.66,0.56,1.09,1.33,1.24,2.19 c0.18,1.07,0.1,2.18-0.21,3.22c-0.29,1.15-0.78,2.23-1.46,3.19c-0.62,0.88-1.42,1.61-2.35,2.13c-0.88,0.48-1.85,0.73-2.85,0.73 c-0.71,0.03-1.41-0.15-2.02-0.51c-0.47-0.28-0.83-0.71-1.03-1.22l-0.06-0.2l-1.77,6.75h-3.43l3.51-13.4l0.02-0.06l0.01-0.06 l0.86-3.25h3.35l-0.57,1.88l-0.01,0.08c0.49-0.7,1.15-1.27,1.91-1.64c0.76-0.4,1.6-0.6,2.45-0.6C90.84,9.43,91.7,9.71,92.4,10.25 L92.4,10.25z M88.26,12.11c-0.4-0.01-0.8,0.07-1.18,0.22c-0.37,0.15-0.71,0.38-1,0.66c-0.68,0.7-1.15,1.59-1.36,2.54 c-0.3,1.11-0.28,1.95,0.02,2.53c0.3,0.58,0.87,0.88,1.72,0.88c0.81,0.02,1.59-0.29,2.18-0.86c0.66-0.69,1.12-1.55,1.33-2.49 c0.29-1.09,0.27-1.96-0.03-2.57S89.08,12.11,88.26,12.11L88.26,12.11z M103.66,9.99c0.46,0.29,0.82,0.72,1.02,1.23l0.07,0.19 l0.44-1.66h3.36l-3.08,11.7h-3.37l0.45-1.73c-0.51,0.61-1.15,1.09-1.87,1.42c-0.7,0.32-1.45,0.49-2.21,0.49 c-0.88,0.04-1.76-0.21-2.48-0.74c-0.66-0.52-1.1-1.28-1.24-2.11c-0.18-1.06-0.12-2.14,0.19-3.17c0.3-1.15,0.8-2.24,1.49-3.21 c0.63-0.89,1.44-1.64,2.38-2.18c0.86-0.5,1.84-0.77,2.83-0.77C102.36,9.43,103.06,9.61,103.66,9.99L103.66,9.99z M101.92,12.14 c-0.41,0-0.82,0.08-1.19,0.24c-0.38,0.16-0.72,0.39-1.01,0.68c-0.67,0.71-1.15,1.59-1.36,2.55c-0.28,1.08-0.28,1.9,0.04,2.49 c0.31,0.59,0.89,0.87,1.75,0.87c0.4,0.01,0.8-0.07,1.18-0.22s0.71-0.38,1-0.66c0.59-0.63,1.02-1.38,1.26-2.22l0.08-0.31 c0.3-1.11,0.29-1.96-0.03-2.53C103.33,12.44,102.76,12.14,101.92,12.14L101.92,12.14z M81.13,9.63l0.22,0.09l-0.86,3.19 c-0.49-0.26-1.03-0.39-1.57-0.39c-0.82-0.03-1.62,0.24-2.27,0.75c-0.56,0.48-0.97,1.12-1.18,1.82l-0.07,0.27l-1.6,6.11h-3.42 l3.1-11.7h3.37l-0.44,1.72c0.42-0.58,0.96-1.05,1.57-1.4c0.68-0.39,1.44-0.59,2.22-0.59C80.51,9.48,80.83,9.52,81.13,9.63 L81.13,9.63z M68.5,10.19c0.76,0.48,1.31,1.24,1.52,2.12c0.25,1.06,0.21,2.18-0.11,3.22c-0.3,1.18-0.83,2.28-1.58,3.22 c-0.71,0.91-1.61,1.63-2.64,2.12c-1.05,0.49-2.19,0.74-3.35,0.73c-1.22,0-2.22-0.24-3-0.73c-0.77-0.48-1.32-1.24-1.54-2.12 c-0.24-1.06-0.2-2.18,0.11-3.22c0.3-1.17,0.83-2.27,1.58-3.22c0.71-0.9,1.62-1.63,2.66-2.12c1.06-0.49,2.22-0.75,3.39-0.73 C66.57,9.41,67.6,9.67,68.5,10.19L68.5,10.19z M64.84,12.1c-0.81-0.01-1.59,0.3-2.18,0.86c-0.61,0.58-1.07,1.43-1.36,2.57 c-0.6,2.29-0.02,3.43,1.74,3.43c0.8,0.02,1.57-0.29,2.15-0.85c0.6-0.57,1.04-1.43,1.34-2.58c0.3-1.13,0.31-1.98,0.01-2.57 C66.25,12.37,65.68,12.1,64.84,12.1L64.84,12.1z M57.89,9.76l-0.6,2.32l-7.55,6.67h6.06l-0.72,2.73H45.05l0.63-2.41l7.43-6.57 h-5.65l0.72-2.73H57.89L57.89,9.76z M40.96,9.99c0.46,0.29,0.82,0.72,1.02,1.23l0.07,0.19l0.44-1.66h3.37l-3.07,11.7h-3.37 l0.45-1.73c-0.51,0.6-1.14,1.08-1.85,1.41s-1.48,0.5-2.27,0.5c-0.88,0.04-1.74-0.22-2.45-0.74c-0.66-0.52-1.1-1.28-1.24-2.11 c-0.18-1.06-0.12-2.14,0.19-3.17c0.29-1.15,0.8-2.24,1.49-3.21c0.63-0.89,1.44-1.64,2.37-2.18c0.86-0.5,1.84-0.76,2.83-0.76 C39.66,9.44,40.36,9.62,40.96,9.99L40.96,9.99z M39.23,12.14c-0.41,0-0.81,0.08-1.19,0.24c-0.38,0.16-0.72,0.39-1.01,0.68 c-0.68,0.71-1.15,1.59-1.36,2.55c-0.28,1.08-0.27,1.9,0.04,2.49c0.31,0.59,0.89,0.87,1.75,0.87c0.4,0.01,0.8-0.07,1.18-0.22 c0.37-0.15,0.72-0.38,1-0.66c0.59-0.62,1.03-1.38,1.26-2.22l0.08-0.31c0.29-1.11,0.26-1.94-0.03-2.53 C40.64,12.44,40.06,12.14,39.23,12.14L39.23,12.14z M26.85,7.81h-3.21l-1.13,4.28h3.21c1.01,0,1.81-0.17,2.35-0.52 c0.57-0.37,0.98-0.95,1.13-1.63c0.2-0.72,0.11-1.27-0.27-1.62C28.55,7.99,27.86,7.81,26.85,7.81L26.85,7.81z"/>
        <polygon className="st0" points="18.4,0 12.76,21.47 8.89,21.47 12.7,6.93 6.86,10.78 7.9,6.95 18.4,0"/>
      </g>
    </svg>
  </span>
);

const BookingSummary = ({ bookingData, selectedBeds, onEditBeds, paymentMethod, setPaymentMethod, termsChecked: termsCheckedProp, setTermsChecked: setTermsCheckedProp }) => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const openTermsModal = () => setShowTermsModal(true);
  const closeTermsModal = () => setShowTermsModal(false);

  // Fallback to local state if termsChecked/setTermsChecked are not provided
  const [internalTermsChecked, setInternalTermsChecked] = useState(false);
  const termsChecked = typeof termsCheckedProp === 'boolean' ? termsCheckedProp : internalTermsChecked;
  const setTermsChecked = typeof setTermsCheckedProp === 'function' ? setTermsCheckedProp : setInternalTermsChecked;
  const { beds, start, end, nights, total, location, package: selectedPackage } = bookingData;
  
  // Determine price based on package or bookingData pricePerBed
  const pricePerBed = selectedPackage ? selectedPackage.price : (bookingData.pricePerBed || 699);
  const isPackageBooking = !!selectedPackage;
  
  // Calculate correct total if not provided or is 0 (with Diwali discount for Regular Plan 12–24 Hours)
  const calculateCorrectTotal = () => {
    const diwaliActive = isDiwaliOfferActive();
    let baseRoom = 0;
    let discount = 0;
    
    if (isPackageBooking) {
      if (selectedPackage.plan === 'Hourly Plan') {
        baseRoom = selectedPackage.price * beds;
      } else if (selectedPackage.plan === 'Weekly Plan') {
        const extraNights = Math.max(0, (parseInt(nights) || 0) - 6);
        baseRoom = beds * (3499 + extraNights * 599);
      } else if (selectedPackage.plan === 'Monthly Plan') {
        const extraNights = Math.max(0, (parseInt(nights) || 0) - 30);
        baseRoom = beds * (11999 + extraNights * 599);
      } else {
        baseRoom = selectedPackage.price * beds * nights; // Regular Plan base
        const eligible = diwaliActive && (selectedPackage.duration || '').includes('12-24');
        if (eligible) {
          discount = getRegularPlanDiscountPerNight() * beds * nights; // ₹100 per bed per night
        }
      }
    } else {
      baseRoom = pricePerBed * beds * nights;
    }
    
    const baseAfterDiscount = Math.max(0, baseRoom - discount);
    const convenienceFee = Math.round(baseAfterDiscount * 0.05);
    return baseAfterDiscount + convenienceFee;
  };
  
  // Always calculate total for package bookings to ensure accuracy
  const correctTotal = isPackageBooking ? calculateCorrectTotal() : (total && total > 0 ? total : calculateCorrectTotal());
  
  const getRoomLabel = (roomId) => {
    switch(roomId) {
      case 'A': return 'Room A (Mixed Dormitory)';
      case 'B': return 'Room B (Female/Family Dormitory)';
      default: return 'Not specified';
    }
  };
  
  return (
    <div className="booking-summary-card">
      <div className="booking-summary-header">
        <h2>Booking Summary</h2>
        <p>Review your booking details before payment</p>
      </div>
      
      <div className="booking-summary-content">
        <div className="summary-section">
          <h3><FaCalendarAlt /> {isPackageBooking ? 'Package Details' : 'Stay Details'}</h3>
          {isPackageBooking ? (
            <>
              <div className="summary-row">
                <span>Package</span>
                <span>{selectedPackage.plan}</span>
              </div>
              <div className="summary-row">
                <span>Duration</span>
                <span>{selectedPackage.duration}</span>
              </div>
              <div className="summary-row">
                <span>Check-in</span>
                <span>{start}</span>
              </div>
              <div className="summary-row">
                <span>Check-out</span>
                <span>{end}</span>
              </div>
            </>
          ) : (
            <>
              <div className="summary-row">
                <span>Check-in</span>
                <span>{start}</span>
              </div>
              <div className="summary-row">
                <span>Check-out</span>
                <span>{end}</span>
              </div>
              <div className="summary-row">
                <span>Duration</span>
                <span>{nights} nights</span>
              </div>
            </>
          )}
        </div>
        
        <div className="summary-section">
          <h3><FaBed /> Bed Selection</h3>
          <div className="summary-row">
            <span>Number of Beds</span>
            <span>{beds} bed{beds > 1 ? 's' : ''}</span>
          </div>

          <div className="summary-row selected-beds-row">
  <div className="selected-beds-label">Selected Beds</div>
  <div className="selected-beds-list">
    {selectedBeds.length ? (
      <>
        {selectedBeds.map((bed, idx) => (
          <div key={bed.id} className="bed-line">
            {`${bed.id} (${bed.position}, Room ${bed.roomId})`}{idx < selectedBeds.length - 1 ? ',' : ''}
          </div>
        ))}
        <button className="edit-beds-btn" onClick={onEditBeds}>
          Edit
        </button>
      </>
    ) : (
      <div className="no-beds">No beds selected</div>
    )}
  </div>
</div>
        </div>
        
        <div className="summary-section facilities-section">
          <h3><FaTools /> Facilities</h3>
          <div className="facilities-grid">
            <div className="facility-item"><FaWifi className="amenity-icon" /> Free WiFi</div>
            <div className="facility-item"><FaCar className="amenity-icon" /> Parking</div>
            <div className="facility-item"><FaSnowflake className="amenity-icon" /> Centralised AC</div>
            <div className="facility-item"><FaRegClock className="amenity-icon" /> 24/7 Support</div>
            <div className="facility-item"><FaToilet className="amenity-icon" /> Clean Washrooms</div>
            <div className="facility-item"><FaLock className="amenity-icon" /> Lockers</div>
            <div className="facility-item"><FaBed className="amenity-icon" /> Cozy Beds</div>
            <div className="facility-item"><FaBolt className="amenity-icon" /> Personal Charging Point</div>
            <div className="facility-item"><FaConciergeBell className="amenity-icon" /> Guest Reception</div>
          </div>
        </div>

        <div className="summary-section payment-method-section">
          <h3>Payment Method</h3>
          <div className="payment-method-options">
            <label className={`payment-method-option${paymentMethod === 'razorpay' ? ' selected' : ''}`}
  htmlFor="razorpay"
>
  <input
    type="radio"
    id="razorpay"
    name="paymentMethod"
    value="razorpay"
    checked={paymentMethod === 'razorpay'}
    onChange={e => setPaymentMethod(e.target.value)}
  />
  <RazorpayLogo />
  <span>Razorpay (Cards, UPI, Net Banking)</span>
</label>
          </div>
        </div>
        
        <div className="summary-section pricing">
          <h3>Pricing Breakdown</h3>
          {isPackageBooking ? (
            // Package-based booking
            <>
              <div className="summary-row">
                <span>{selectedPackage.plan} - {selectedPackage.duration}</span>
                <span>
                  {selectedPackage.plan === 'Hourly Plan' 
                    ? `₹${selectedPackage.price} × ${beds} bed${beds > 1 ? 's' : ''}` 
                    : selectedPackage.plan === 'Weekly Plan'
                    ? `₹${selectedPackage.price} × ${beds} bed${beds > 1 ? 's' : ''}`
                    : selectedPackage.plan === 'Monthly Plan'
                    ? `₹${selectedPackage.price} × ${beds} bed${beds > 1 ? 's' : ''}`
                    : `₹${selectedPackage.price} × ${beds} bed${beds > 1 ? 's' : ''} × ${nights} night${nights > 1 ? 's' : ''}`
                  }
                </span>
                <span>
                  ₹{selectedPackage.plan === 'Hourly Plan' || selectedPackage.plan === 'Weekly Plan' || selectedPackage.plan === 'Monthly Plan'
                    ? selectedPackage.price * beds 
                    : selectedPackage.price * beds * nights
                  }
                </span>
              </div>
              {/* Diwali discount row for Regular Plan 12–24 Hours */}
              {(selectedPackage.plan === 'Regular Plan' && (selectedPackage.duration || '').includes('12-24') && isDiwaliOfferActive()) && (
                <div className="summary-row">
                  <span>Diwali Offer</span>
                  <span>- ₹100 × {beds} bed{beds > 1 ? 's' : ''} × {nights} night{nights > 1 ? 's' : ''}</span>
                  <span>-₹{100 * beds * nights}</span>
                </div>
              )}
              
              <div className="summary-row">
                <span>Convenience Fee</span>
                <span>5%</span>
                <span>{(() => {
                  const diwaliActive = isDiwaliOfferActive();
                  const base = (selectedPackage.plan === 'Hourly Plan' || selectedPackage.plan === 'Weekly Plan' || selectedPackage.plan === 'Monthly Plan')
                    ? selectedPackage.price * beds
                    : selectedPackage.price * beds * nights;
                  const discount = (selectedPackage.plan === 'Regular Plan' && (selectedPackage.duration || '').includes('12-24') && diwaliActive)
                    ? 100 * beds * nights
                    : 0;
                  const fee = Math.round((Math.max(0, base - discount)) * 0.05);
                  return `₹${fee}`;
                })()}
                </span>
              </div>
              <hr className="summary-divider" />
              <div className="summary-row total">
                <span>Total Amount</span>
                <span>₹{correctTotal}</span>
              </div>
            </>
          ) : (
            // Dormitory booking with dates
            <>
              <div className="summary-row">
                <span>Room Charges</span>
                <span>₹{pricePerBed} × {beds} bed × {nights} nights</span>
                <span>₹{pricePerBed * beds * nights}</span>
              </div>
              <div className="summary-row">
                <span>Convenience Fee</span>
                <span>5%</span>
                <span>₹{Math.round((pricePerBed * beds * nights) * 0.05)}</span>
              </div>
              <hr className="summary-divider" />
              <div className="summary-row total">
                <span>Total Amount</span>
                <span>₹{correctTotal}</span>
              </div>
            </>
          )}
          <div className="cancellation-policy">
            <span className="policy-text">✓ Free cancellation up to 24 hours before check-in</span>
          </div>
        </div>

        {/* Terms and Conditions Section */}
        <div className="terms-section">
          <label className="terms-checkbox-label">
            <input
              type="checkbox"
              checked={termsChecked}
              onChange={e => setTermsChecked(e.target.checked)}
              required
            />
            I have read the <span className="terms-link" onClick={openTermsModal}>Terms and Conditions</span>
          </label>
        </div>

        {/* Terms Modal Popup */}
        {showTermsModal && (
          <div className="terms-modal-overlay" onClick={closeTermsModal}>
            <div className="terms-modal" onClick={e => e.stopPropagation()}>
              <button className="close-terms-modal" onClick={closeTermsModal}>&times;</button>
              <h2>Dormitory Stay Terms & Conditions</h2>
              <ul className="terms-list">
                <li>Valid government photo ID required at check-in (Aadhaar, Passport, DL, etc.).</li>
                <li>Check-in time: 12:00 PM | Check-out time: 11:00 AM.</li>
                <li>Only registered guests allowed in dormitory areas. No outside visitors permitted.</li>
                <li>Quiet hours: 10:00 PM to 7:00 AM. Please respect fellow guests.</li>
                <li>Alcohol, drugs, and smoking strictly prohibited inside the property.</li>
                <li>Lockers are provided. Management is not responsible for lost or stolen items.</li>
                <li>Maintain cleanliness in all shared spaces and washrooms.</li>
                <li>Any damage to property will be charged to the guest.</li>
                <li>Management reserves the right to refuse entry or evict guests for inappropriate behavior.</li>
                <li>Full payment required at check-in. No refunds for early check-out.</li>
              </ul>
              <div className="terms-contact-note">
                For any questions, contact us at <a href="mailto:booking@skylinebackpackers.in">booking@skylinebackpackers.in</a> or call +91 90327 97797.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingSummary;
export { BookingSummary };
